import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDate } from '@platform/core/lib/format';
import { useAppSelector } from '@platform/state/hooks';
import { selectLang } from '@platform/state/selectors';
import { agoParts } from './agoParts';

/** Відносний час прототипу мовою інтерфейсу: «щойно», «5 хв тому», «3 год тому», «2 дн. тому», старіше — «13 жовт.». */
export function useAgo(): (iso: string) => string {
  const { t } = useTranslation();
  const lang = useAppSelector(selectLang);
  return useCallback((iso: string) => {
    const p = agoParts(iso);
    return p.unit === 'date' ? formatDate(iso, lang) : t(`recordPage.ago.${p.unit}`, { count: p.count });
  }, [t, lang]);
}
